import React from "react";
import {
  FormControl,
  OutlinedInput,
  Fade,
  FormHelperText,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { ValidatorComponent } from "react-material-ui-form-validator";
import { Visibility, VisibilityOff } from "@material-ui/icons";

class PasswordField extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      value,
      name,
      inputProps,
      placeholder,
      autoComplete,
      type,
      onChange,
      onCut,
      onCopy,
      onPaste,
    } = this.props;
    return (
      <div>
        <FormControl  fullWidth>
          <OutlinedInput 
          style={{backgroundColor:"white"}}
            name={name}
            value={value}
            inputProps={inputProps}
            placeholder={placeholder}
            autoComplete={autoComplete}
            type={type}
            error={this.errorText() !== null ? true : false}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  edge="end"
                  onClick={this.props.iconButtonOnClick}
                  onMouseDown={this.props.iconButtononMouseDown}
                >
                  {this.props.showPass ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            onChange={onChange}
            onCut={onCut}
            onCopy={onCopy}
            onPaste={onPaste}
          />
        </FormControl>
        {(name === "password" && onPaste)&& this.renderRules(value)}
        {name !== "password" && this.errorText()}
      </div>
    );
  }

 errorText() {
    const { isValid } = this.state;
    if (isValid) return null;
   

    return (
      <Fade in={true}>
        <FormHelperText style={{ color: "red" }}>
          {this.getErrorMessage()}
        </FormHelperText>
      </Fade>
    );
  }

  renderRules(value) {
    if (!value) return null;

    const rules = [
      { test: /[a-z]/.test(value), label: "1 lowercase letter" },
      { test: /[A-Z]/.test(value), label: "1 uppercase letter" },
      { test: /[0-9]/.test(value), label: "1 number" },
      { test: /[!@#$%^&*]/.test(value), label: "1 special character (!@#$%^&*)" },
      { test: value.length >= 8, label: "minimum of 8 characters" },
      { test: value.length <= 64, label: "maximum of 64 characters" },
    ];
    const missing = rules.filter((rule) => !rule.test);

  if (missing.length === 0) return null;

    return (
      <Fade in={true}>
        <FormHelperText style={{ color: "red" }}>
          {`Password must contain ${missing.map(rule=>rule.label).join(", ")}.`}
  
        </FormHelperText>
      </Fade>
    );
  }
}

export default PasswordField;
